"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { ShoppingBag} from "lucide-react"
import React from "react"
import Image from "next/image"

// Define the shape of a single product
interface Product {
  id: number
  name: string
  price: string
  description: string
  mainImage: string
  thumbnails?: string[]
}

interface ProductDetailDialogProps {
  product: Product | null; // The product to display, or null if none
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export default function ProductDetailDialog({ product, isOpen, onOpenChange }: ProductDetailDialogProps) {
  const [selectedImage, setSelectedImage] = useState(product?.mainImage || "");

  // Update selected image when the product prop changes
  React.useEffect(() => {
    if (product) {
      setSelectedImage(product.mainImage);
    }
  }, [product]);

  if (!product) {
    return null; // Don't render anything if no product is selected
  }

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl bg-background-main border-slate-600 text-white p-0">
        <DialogHeader className="p-6 pb-0">
          <div className="flex items-center justify-between">
            <DialogTitle className="text-xl font-medium">Product Details</DialogTitle>
          </div>
        </DialogHeader>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
          {/* Image Gallery */}
          <div className="flex flex-col gap-4">
            <div className="rounded-lg p-8 flex items-center justify-center h-96">
              <Image
                src={selectedImage}
                alt={product.name}
                width={400}
                height={400}
                className="max-h-full max-w-full object-contain"
              />
            </div>
            {/* <div className="flex justify-center gap-3">
              {product.thumbnails.map((thumb, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedImage(thumb)}
                  className={`w-20 h-20 rounded-lg overflow-hidden border-2 transition-colors ${
                    selectedImage === thumb ? "border-white" : "border-slate-500"
                  }`}
                >
                  <Image
                    src={thumb}
                    alt={`View ${index + 1}`}
                    width={80}
                    height={80}
                    className="w-full h-full object-cover bg-white"
                  />
                </button>
              ))}
            </div> */}
          </div>

          {/* Product Details */}
          <div className="flex flex-col space-y-4">
            <div>
              <h2 className="text-2xl font-medium mb-2">{product.name}</h2>
              <p className="text-3xl font-semibold text-white">{product.price}</p>
            </div>
            <p className="text-white text-sm leading-relaxed">{product.description}</p>
            <Button className="w-full bg-slate-600 hover:bg-slate-500 text-white py-3 mt-auto">
              <ShoppingBag className="mr-2 h-4 w-4" />
              Add To Basket
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}